import { Button, Select, DatePicker, Row, Col } from 'antd'
import React, { useEffect, useState } from 'react'
import { fetchMarketPlaces } from 'src/api/reports'
import { SearchOutlined } from '@ant-design/icons'
import { fetchCountryProvider } from 'src/api/authen'
import { UserNameAutoCompleteWithId } from 'src/components/Search/UserNameSearchWithId'
import moment from 'moment'
import { STATESOPTIONS } from 'src/constants'
import { fetchUserInfo } from 'src/api/authen'

interface RedeemUserProps {
  appendSearchForm: (obj: any) => void
  submitSearchForm: () => void
}

const RedeemUserSearch: React.FC<RedeemUserProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  const [country, setCountry] = useState('')
  const [countries, setCountries] = useState([])
  
  const initialstatDate = moment().subtract(365, 'days').startOf('day')
  const initialEndDate = moment().endOf('day')
  const [statDate, setstatDate] = useState(initialstatDate)
  const [endDate, setEndDate] = useState(initialEndDate)
  const [state, setState] = useState('')
  
  const [criteria, setCriteria] = useState<any>({})
  const [products, setProducts] = useState([])
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null)
  const [redeemUser, setRedeemUser] = useState(false)

  const updateCriteria = (obj: any) => {
    setCriteria((prev) => ({ ...prev, ...obj }))
    appendSearchForm(obj)
  }

  const fetchCountry = async () => {
    try {
      const data = await fetchCountryProvider()
      const countryOptions = data.data.map((item) => ({
        label: item.countryName,
        value: item.countryCode,
      }))
      countryOptions.unshift({ label: 'All', value: '' })
      setCountries(countryOptions)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const fetchUserAccess = async () => {
    try {
      const { data } = await fetchUserInfo()
      setRedeemUser(
        data != null && data.permissions != null
          ? !data.permissions.includes('redeem-users-view')
          : true
      )
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleSearchClick = () => {
  appendSearchForm({ buttonAction: '' })
  submitSearchForm()
}

  const handleProductChange = (value: string) => {
    setSelectedProduct(value)
    updateCriteria({ marketplaceId: value })
  }

  const handleStateChange = (value) => {
    setState(value)
    appendSearchForm({ state: value, buttonAction: '' })
    submitSearchForm()
  }

  const fetchProducts = async () => {
    try {
      const response = await fetchMarketPlaces()
      const productOptions = response
        .map((item: any) => ({
          label: item.name,
          value: item.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
      setProducts(productOptions)
    } catch (error) {
      console.error('Error fetching products:', error)
    }
  }

  useEffect(() => {
    fetchCountry()
    updateCriteria({ statDate: initialstatDate.format('YYYY-MM-DD') })
    updateCriteria({ endDate: initialEndDate.format('YYYY-MM-DD') })
    updateCriteria({ state: '' })
    updateCriteria({ providerCountry: country })
    submitSearchForm()
    fetchProducts()
    fetchUserAccess()
  }, [])

  
  return (
    <div className="master-search-wrap">
      <Row gutter={15}>
        <Col span={4}>
          <UserNameAutoCompleteWithId
            appendSearchForm={appendSearchForm}
            updateCriteria={updateCriteria}
          />
        </Col>
        <Col span={4}>
          <Select
            allowClear
            showSearch
            placeholder="Select Product"
            value={selectedProduct}
            onChange={handleProductChange}
            optionFilterProp="label"
            filterOption={(input, option) => {
              const label = String(option?.label ?? '')
              return label.toLowerCase().includes(input.toLowerCase())
            }}
            style={{ width: '100%' }}
          >
            {products.map(({ label, value }) => (
              <Select.Option key={value} value={value} label={label}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        {/* {redeemUser && (
          <Col span={3}>
            <Input
              placeholder="Country"
              allowClear
              onChange={(e) => {
                appendSearchForm({ country: e.target.value })
                if (e.target.value === '') submitSearchForm()
              }}
            />
          </Col>
        )} */}

        {redeemUser && (
          <Col span={4}>
            <Select
              placeholder="Provider Country"
              onChange={(value) => {
                setCountry(value)
                appendSearchForm({ providerCountry: value, buttonAction: '' })
                submitSearchForm()
              }}
              allowClear
              onClear={() => {
                setCountry('')
                appendSearchForm({ providerCountry: '', buttonAction: '' })
                submitSearchForm()
              }}
              value={country}
              showSearch
              className="search-input"
              style={{ width: '100%' }}
            >
              {countries.map((country) => (
                <Select.Option value={country.value} key={country.value}>
                  {country.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        )}

        <Col span={3}>
          <Select
            placeholder="Select Status"
            onChange={(value) => handleStateChange(value)}
            options={STATESOPTIONS}
            value={state}
            style={{ width: '100%' }}
            allowClear
          />
        </Col>

        <Col span={5}>
          <DatePicker.RangePicker
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            value={[statDate, endDate]}
            clearIcon
            onChange={(dates) => {
              const newStart = dates?.[0] || null
              const newEnd = dates?.[1] || null
              setstatDate(newStart)
              setEndDate(newEnd)
              updateCriteria({
                statDate: newStart ? newStart.format('YYYY-MM-DD') : '',
                endDate: newEnd ? newEnd.format('YYYY-MM-DD') : '',
              })
            }}
          />
        </Col>

        <Col span={4}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearchClick}
            className="btn-primary"
            size="middle"
          >
            Search
          </Button>
        </Col>
      </Row>
    </div>
  )
}

RedeemUserSearch.displayName = 'RedeemUserSearch'
export default RedeemUserSearch
